import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export function ReporteInvalidados({ data }) {
  const loads = data?.loads_invalidados?.items || [];
  const costos = data?.costos_anulados?.items || [];
  return (
    <div className="space-y-8">
      <div>
        <h3 className="mb-2 text-sm font-semibold text-foreground">Loads invalidados ({loads.length})</h3>
        <Table data-testid="reporte-invalidados-loads-table">
          <TableHeader>
            <TableRow>
              <TableHead>Load</TableHead><TableHead>Cliente</TableHead><TableHead>Invalidado en</TableHead>
              <TableHead>Por</TableHead><TableHead>Motivo</TableHead><TableHead>Reemplazado por</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loads.map((r) => (
              <TableRow key={r.numero_load} data-testid={`reporte-invalidados-row-${r.numero_load}`}>
                <TableCell className="font-mono text-xs">{r.numero_load}</TableCell>
                <TableCell>{r.client_nombre}</TableCell>
                <TableCell className="text-xs">{(r.invalidado_en || "").slice(0, 10)}</TableCell>
                <TableCell className="text-xs">{r.invalidado_por}</TableCell>
                <TableCell className="text-xs">{r.motivo_invalidacion}</TableCell>
                <TableCell className="font-mono text-xs">{r.reemplazado_por || "—"}</TableCell>
              </TableRow>
            ))}
            {loads.length === 0 && (
              <TableRow><TableCell colSpan={6} className="text-center text-sm text-muted-foreground py-6">Sin loads invalidados en el período.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <div>
        <h3 className="mb-2 text-sm font-semibold text-foreground">Costos anulados ({costos.length})</h3>
        <Table data-testid="reporte-anulados-costos-table">
          <TableHeader>
            <TableRow>
              <TableHead>Load</TableHead><TableHead>Tipo de costo</TableHead><TableHead className="text-right">Monto</TableHead>
              <TableHead>Anulado en</TableHead><TableHead>Por</TableHead><TableHead>Motivo</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {costos.map((r) => (
              <TableRow key={`${r.numero_load}-${r.tipo_costo}-${r.anulado_en}`} data-testid={`reporte-anulados-row-${r.numero_load}`}>
                <TableCell className="font-mono text-xs">{r.numero_load}</TableCell>
                <TableCell className="text-xs">{r.tipo_costo}</TableCell>
                <TableCell className="text-right">{r.monto} {r.moneda}</TableCell>
                <TableCell className="text-xs">{(r.anulado_en || "").slice(0, 10)}</TableCell>
                <TableCell className="text-xs">{r.anulado_por}</TableCell>
                <TableCell className="text-xs">{r.motivo_anulacion}</TableCell>
              </TableRow>
            ))}
            {costos.length === 0 && (
              <TableRow><TableCell colSpan={6} className="text-center text-sm text-muted-foreground py-6">Sin costos anulados en el período.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
